<template>
    <v-dialog v-model="shown" width="1100px" persistent>
        <v-card v-if="model">
            <v-card-title
                class="headline"
            >{{isNew ? 'Create' : 'Edit'}} Announcement</v-card-title>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-text-field
                                v-model="model.title"
                                label="Title"
                                v-validate="'required'"
                                :error-messages="errors.collect('title')"
                                name="title"
                                required
                                :disabled="!userIsFleetManager"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-textarea
                                v-model="model.content"
                                label="Content"
                                :error-messages="errors.collect('content')"
                                name="content"
                                :disabled="!userIsFleetManager"
                            ></v-textarea>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    offset-y
                    @click="publish"
                    v-if="!model.publishedOn && model.id">
                    <v-icon>campaign</v-icon>&nbsp;Publish
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    @click="submit"
                    :loading="saving"
                    v-if="userIsFleetManager"
                >Save</v-btn>
                <v-btn text @click="shown=false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import moment from 'moment';
import { DateFormat } from '@/plugins/date-filter';
import AnnouncementClient from '@/components/Announcements/AnnouncementClient.vue';
import FormValidation from '../FormValidation.vue';

export default {
    mixins: [AnnouncementClient, FormValidation],
    data() {
        return {
            model: null,
            shown: false,
            isNew: false,
            saving: false,
            minDate: moment(new Date()).format(DateFormat.Canonical)
        };
    },
    computed: {
    },
    methods: {
        show(model) {
            this.isNew = false;
            this.shown = true;
            this.model = model;
            this.reset();
        },
        create() {
            this.isNew = true;
            this.shown = true;
            this.model = {
                title: '',
                content: '',
            };
            this.reset();
        },
        reset() {
            this.$validator.reset();
            this.saving = false;
        },
        async submitForm() {
            this.saving = true;
            const model = {
                id: this.isNew ? null : this.model.id,
                title: this.model.title,
                content: this.model.content,
            };
            const response = await (this.isNew ? this.addAnnouncement(model) : this.updateAnnouncement(model));
            if (response.status >= 200 && response.status < 300) {
                this.shown = false;
            }
            this.saving = false;
        },
        async publish() {
            this.saving = true;

            if (this.isNew) {
                return;
            }

            if (await this.markAnnouncementAsPublished(this.model.id)) {
                this.shown = false;
            }

            this.saving = false;
        }
    }
};
</script>
<style lang="scss">
.vh50 {
    height: 50vh;
    overflow-y: scroll;
}
</style>
